<template>
  <div class="bar" style="margin-top: -30px;position: relative;width: 100%;z-index: 100;">
    <img :src="`${pre}hero/yellow.png`" class="gold-border-1" />
  </div>
  <div class="intro2">
    <div class="intro-wrapper">
      <div class="intro2__wrapper">
        <div class="left">
          
          <img class="left__img left__img--sign" :src="`${pre}sign-board.png`" />
          <img class="left__img left__img--chains" :src="`${pre}sign-chains.png`" />
        </div>
        <div class="right">
          <div class="paragraph-1">
            CAPTAIN MORGAN ORIGINAL SPICED GOLD IS BLENDED USING<br />
            THE FINEST CARIBBEAN RUMS.
          </div>
          <div class="paragraph-2">
            MADE USING REAL VANILLA AND MATURED IN BOURBON BARRELS <br />YOU’LL
            GET A RICH, SWEET FLAVOUR WITH A SMOOTH FINISH.
          </div>
          <div>
            <span class="intro-title" style="font-size: 20px"
              >WHY NOT EMBARK ON <br />YOUR OWN ADVENTURE?</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import gsap from "gsap";
$(document).ready(function () {
  gsap.set(".left__img--sign", {
    rotate: -5,
    y: -10,
    rotationY: -20,
    rotationX: -10,
    x: 30,
  });
  var tl_1 = gsap.timeline({ repeat: -1 });
  tl_1
    .to(".left__img--sign", {
      rotate: 5,
      duration: 2.5,
      ease: "Power2.easeInOut",
      transformOrigin: "60% 50%",
      rotationY: -30,
      rotationX: 10,
      x: 0,
      x: -30,
    })
    .to(".left__img--sign", {
      rotate: -5,
      duration: 2.5,
      ease: "Power2.easeInOut",
      transformOrigin: "60% 50%",
      rotationY: -20,
      rotationX: -10,
      x: 30,
    });
  gsap.set(".left__img--chains", {
    rotate: -10,
    y: -10,
  });
  var tl_2 = gsap.timeline({ repeat: -1 });
  tl_2
    .to(".left__img--chains", {
      rotate: 10,
      duration: 2.5,
      ease: "Power2.easeInOut",
      transformOrigin: "50% 0%",
    })
    .to(".left__img--chains", {
      rotate: -10,
      duration: 2.5,
      ease: "Power2.easeInOut",
    });
});
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  }, 
  pre: {
    type: String,
    default: "1",
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.gold-border-1 {
  width: 40%;
  height: 30px;
  opacity: 1;
  position: absolute;
  left: 0px;
  top: -15px; 
  @media (max-width: 750px) {
    height: 20px;
    width: calc(100% - 10px);
    top: -10px;
  }
}
.intro2 {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  overflow: hidden;
  width: 100%;
  margin-top: -30px;
  
}
.intro2__wrapper {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  max-width: 1280px;
  width: 100%;
}

.left {
  @include align-self(flex-start);
  position: relative;

}
.left__img--chains {
  left: 0px;
  top: 0px;
  position: absolute;
  z-index: 1;
}
.left__img--sign {
  position: relative;
  z-index: 2;
}
.left__img {
  max-width: 500px;
  width: 100%;
  margin-top: -10px;
}
.right {
  font-size: 20px;
  font-weight: 900;
  color: white;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.paragraph-1,
.paragraph-2 {
  font-size: 35px;
  line-height: 38px;
  margin-bottom: 35px;
}
.intro-title {
  font-size: 45px !important;
  line-height: 50px;
  font-family: CaptainRefined, sans-serif !important;
  font-weight: 400;
}
@media (max-width: 770px) {
.right {
    padding: 50px 30px 0px 30px !important;
  }
}
@media (max-width: 750px) {
  .intro2__wrapper {
    flex-direction: column !important;
  }
  .left {
    align-self: center !important;
    width: 100%;
  }
  .right {
    padding-top: 50px !important;
  }
  .left__img {
    margin-top: 0px !important;
  }
  .paragraph-1,
  .paragraph-2 {
    font-size: 25px;
    line-height: 28px;
    margin-bottom: 25px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .intro-title {
    font-size: 43px !important;
    line-height: 48px;
    font-family: CaptainRefined, sans-serif !important;
    font-weight: 400;
    padding-left: 1.5px;
  }
}

@media (max-width: 460px) {
  .left {
    align-self: center !important;
    width: 100%;
    max-width: 200px;
  }
  .paragraph-1,
  .paragraph-2 {
    font-size: 28px !important;
    line-height: 31px !important;
    margin-bottom: 28px !important;
  }
  .intro-title {
    font-size: 47px !important;
    line-height: 48px;
    font-family: CaptainRefined, sans-serif !important;
    font-weight: 400;
    padding-left: 1.5px;
  }
}
@media (max-width: 414px) {
  .intro-title {
    font-size: 43px !important;
  }
}
</style>
